import React, { useState, useEffect } from 'react';
import { Percent } from 'lucide-react';

const StickyPromoButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToForm = () => {
    const formElement = document.getElementById('quote-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      // Fallback to hero section
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToForm}
      className="fixed right-0 top-1/2 -translate-y-1/2 z-50 bg-[#ff5218] hover:bg-[#e54a15] text-white font-oswald font-bold text-sm uppercase px-3 py-4 shadow-lg transition-all hover:shadow-xl hover:pr-4 group"
      style={{
        writingMode: 'vertical-rl',
        textOrientation: 'mixed',
        borderRadius: '8px 0 0 8px',
      }}
      aria-label="Claim 35% roof painting promotion - scroll to quote form"
      data-testid="sticky-promo-button"
    >
      <span className="flex items-center gap-2">
        <Percent className="w-4 h-4 rotate-90 group-hover:animate-pulse" aria-hidden="true" />
        <span>CLAIM 35% ROOF PAINTING PROMOTION</span>
      </span>
    </button>
  );
};

export default StickyPromoButton;
